<template>
  <v-list class="pa-4">
    <v-list-item
      v-for="language in languages"
      :key="language.iso"
      :data-qa="`language-${language.iso}`"
      width="260px"
      class="d-flex align-center justify-center cursor-pointer"
      @click="redirectToOtherLanguage(language)"
    >
      <v-img
        :src="language.flag_image?.url || ''"
        width="24px"
        :alt="language.iso"
        class="mr-4"
      />
      <v-list-item-title>
        {{ language.translations?.[`name_${language.iso}`] || language.name }}
      </v-list-item-title>
      <v-icon
        v-if="language.iso === currentLanguageIso"
        color="primary"
        size="24"
      >
        ui-icon-check
      </v-icon>
    </v-list-item>
  </v-list>
</template>

<script setup lang="ts">
import { toRefs } from 'vue'
import type { ContextStore } from 'src/layouts/core-layout/types'
import sendYaGoal from 'src/utils/sendYaGoal'
import { useContextStore } from 'src/store'

type Language = {
  iso: string
  name: string
  flag_image?: {
    url?: string
  }
  translations?: Record<string, string>
}

const props = defineProps<{
  languages: Language[]
}>()
const { languages } = toRefs(props)

const { context }: ContextStore = useContextStore()
const hasWindow = typeof window !== 'undefined'

const currentLanguageIso = context.current_language?.iso || ''

function redirectToOtherLanguage(language: Language) {
  if (!hasWindow) {
    return
  }

  const currentLanguage = context.current_language?.iso
  const defaultLanguageIso = context.default_language_iso

  if (!language.iso || !currentLanguage || language.iso === currentLanguage) {
    return
  }

  sendYaGoal(`languagesList__click-${language.iso}`)

  const { pathname, origin, search } = window.location
  const isoInUrl = new RegExp(`^/(${currentLanguage})/`)

  if (defaultLanguageIso === language.iso) {
    window.location.href = `${origin}${pathname.replace(isoInUrl, '/')}${search}`
    return
  }

  if (defaultLanguageIso === currentLanguage) {
    window.location.href = `${origin}/${language.iso}${pathname.replace(isoInUrl, '')}${search}`
    return
  }

  window.location.href = `${origin}/${language.iso}/${pathname.replace(isoInUrl, '')}${search}`
}
</script>
